var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2.93115H7.82C4.17 2.93115 2 5.10115 2 8.74115V17.1112C2 20.7512 4.17 22.9212 7.81 22.9212H16.18C19.82 22.9212 21.99 20.7512 21.99 17.1112V8.74115C22 5.10115 19.83 2.93115 16.19 2.93115Z",
    fill: "#5B6B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.35 9.98113L15.01 17.5211C14.45 19.3111 11.94 19.3411 11.35 17.5611L10.65 15.4911C10.46 14.9211 10.01 14.4611 9.43997 14.2811L7.35997 13.5811C5.58997 12.9911 5.61997 10.4611 7.40997 9.92112L14.95 7.57113C16.43 7.12113 17.82 8.51113 17.35 9.98113Z",
    fill: "#5B6B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteSquare);
export default __webpack_public_path__ + "static/media/route-square.eb0e8253d2c650b4f61f0cd1328500d9.svg";
export { ForwardRef as ReactComponent };